export default {_name:'Text.Markdown',module:'Field',view:'Element/Text/Markdown',options:{xs:12,ms:12}}